module.exports = __webpack_public_path__ + "assets/images/figurine_corinne.4846fb8.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/figurines/figurine_corinne.png
// module id = 347
// module chunks = 1